import Controller, { OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { ApplicationRoute } from '../../../constants/routes';

@Controller({ component: 'modal-cookies-policy', fragment: 'cookies-policy' })
class CookiesPolicyController extends BaseController {

  @OnClose({ target: 'modal-cookies-policy' })
  onCloseModal(): void {
    this.historyService.push(ApplicationRoute.LOGIN);
  }
}

export default CookiesPolicyController;